import { render } from "@/components/pages/informationMain/InformationMain.html?vue&type=template&id=d393a872&external"
import script from "@/components/pages/informationMain/InformationMain.js?vue&type=script&lang=js&external"
export * from "@/components/pages/informationMain/InformationMain.js?vue&type=script&lang=js&external"

import "@/components/pages/informationMain/InformationMain.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__